import { render, staticRenderFns } from "./Visit-page.vue?vue&type=template&id=067e5fc7&"
import script from "./Visit-page.vue?vue&type=script&lang=js&"
export * from "./Visit-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports